import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, Bell } from "lucide-react";
import { useAuthStore } from "../../store/authStore";
import Button from "../ui/Button";

export default function HeaderBar({
  toggleMobileSidebar,
  title = "Dashboard",
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const avatarRef = useRef(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const { role, setRole, setUser } = useAuthStore();
  const todayLabel = new Date().toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });


  const handleAvatarClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setIsDropdownOpen(false);
    setRole(null);
    setUser(null);
    navigate("/");
  };

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleClickOutside = (event) => {
      if (
        avatarRef.current &&
        !avatarRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  return (
    <header className="header">
      <div className="header-left header-context">
        <div>
          <p className="header-eyebrow">Workspace</p>
          <h1 className="header-title">{title}</h1>
        </div>
      </div>

      <div className="header-center desktop-only">
        <div className="header-chip">{todayLabel}</div>
        <div className="header-chip">
          Role: {role ? role.charAt(0).toUpperCase() + role.slice(1) : "User"}
        </div>
        <div className="header-chip">Status: Active</div>
      </div>

      <div className="header-right">
        {/* Register */}
        {role === "admin" && (
          <Link
            className="btn w-auto py-1 px-3 d-flex align-center text-sm fw-semibold bg-gradient-primary btn-hover-glow rounded-20 desktop-only"
            to="/register"
          >
            Register Agent
          </Link>
        )}

        {/* Notifications */}
        <button className="icon-btn">
          <Bell size={20} />
          <span className="notification-badge"></span>
        </button>

        {/* Avatar + Dropdown */}
        <div className="position-relative header-avatar-wrap">
          <button
            ref={avatarRef}
            className="avatar cursor-pointer d-flex align-center justify-center"
            onClick={handleAvatarClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleAvatarClick();
              }
            }}
          >
            {role ? role.charAt(0).toUpperCase() : "U"}
          </button> 

          {isDropdownOpen && (
            <div
              ref={dropdownRef}
              className="position-absolute right-0 p-1 rounded-md card-shadow bg-gray-100 dropdown-menu dropdown-animate"
              style={{ minWidth: "150px", zIndex: 100 }}
            >
              <div className="d-flex flex-column">
                <Button
                  className="w-100 text-left py-1 px-2 rounded-sm transition-bg"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </div>
            </div>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          className="header-hamburger mobile-only"
          onClick={toggleMobileSidebar}
        >
          <Menu size={24} />
        </button>
      </div>
    </header>
  );
}